import { Typography, Paper, Skeleton, IconButton } from '@mui/material'
import { Box, Stack } from '@mui/system'
import { DuplicateIcon } from '@sitoo/mui-components'
import { Maybe } from 'graphql/jsutils/Maybe'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

type ActivationBlockProps = {
  loading: boolean
  value: Maybe<string> | undefined
  title: string
}

export const ActivationCodeBlock = (props: ActivationBlockProps) => {
  const { t } = useTranslation(['shared'])
  const { enqueueSnackbar } = useSnackbar()

  const copyToClipboard = () => {
    if (props.value) {
      void navigator.clipboard
        .writeText(props.value)
        .then(() => enqueueSnackbar(t('shared:copied_to_clipboard')))
    }
  }

  return (
    <Box>
      <Typography variant="body02" sx={{ mb: 1, display: 'block' }}>
        {props.title}
      </Typography>

      <Paper
        sx={{ p: 1, background: (theme) => theme.palette.background.default }}
      >
        <Stack direction="row" alignItems="center">
          <Box sx={{ width: '100%', textAlign: 'center' }}>
            <Typography variant="displayLarge">
              {props.loading ? (
                <Skeleton
                  variant="text"
                  width="50%"
                  sx={{ display: 'inline-block' }}
                />
              ) : (
                props.value
              )}
            </Typography>
          </Box>

          <Box>
            <IconButton onClick={copyToClipboard}>
              <DuplicateIcon />
            </IconButton>
          </Box>
        </Stack>
      </Paper>
    </Box>
  )
}
